export default __webpack_public_path__ + "static/tcgl-logo-0ae2e75c4d959af297ba17c45b783769.svg";